import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./PrivacyPolicy.module.scss";
import { LEGAL_CONFIG } from "../../../config/legal";

const PrivacyPolicy = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>
          <FormattedMessage
            id="legal.privacy.title"
            defaultMessage="Privacy Policy, GDPR and personal data protection for {platform}"
            values={{ platform: LEGAL_CONFIG.platformName.toUpperCase() }}
          />
        </h1>

        <section className={styles.section}>
          <h2>§1 Postanowienia ogolne</h2>
          <ol>
            <li>
              Niniejsza Polityka Prywatnosci okresla zasady przetwarzania i
              ochrony danych osobowych Uzytkownikow korzystajacych z internetowej
              platformy sprzedazowej {LEGAL_CONFIG.platformName} sprzedajacej wykroje
              krawieckie w formie cyfrowej (dalej: "Sklep").
            </li>
            <li>
              Administratorem danych osobowych jest wlasciciel Platformy (dalej:
              "Administrator").
            </li>
            <li>
              Administrator przetwarza dane osobowe zgodnie z obowiazujacymi
              przepisami prawa, w szczegolnosci:
              <ul>
                <li>
                  Rozporzadzeniem Parlamentu Europejskiego i Rady (UE) 2016/679
                  (RODO),
                </li>
                <li>ustawa o ochronie danych osobowych,</li>
                <li>
                  ustawa o swiadczeniu uslug droga elektroniczna.
                </li>
              </ul>
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§2 Zakres zbieranych danych</h2>
          <p>
            Administrator moze przetwarzac nastepujace dane osobowe Uzytkownikow:
          </p>
          <ul>
            <li>imie i nazwisko,</li>
            <li>adres e-mail,</li>
            <li>numer telefonu,</li>
            <li>adres zamieszkania lub prowadzenia dzialalnosci,</li>
            <li>dane do faktury,</li>
            <li>adres IP,</li>
            <li>dane zawarte w formularzu kontaktowym,</li>
            <li>dane zwiazane z zamowieniami.</li>
          </ul>
          <p>
            Podanie danych jest dobrowolne, jednak niezbedne do realizacji
            zamowien lub korzystania z uslug Platformy.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§3 Cele przetwarzania danych</h2>
          <p>Dane osobowe przetwarzane sa w celu:</p>
          <ol>
            <li>realizacji zamowien i umow sprzedazy produktow cyfrowych,</li>
            <li>obslugi platnosci i rozliczen,</li>
            <li>prowadzenia konta Klienta,</li>
            <li>kontaktu z Klientem,</li>
            <li>obslugi reklamacji i odstapien od umowy,</li>
            <li>realizacji obowiazkow ksiegowych i podatkowych,</li>
            <li>
              prowadzenia dzialan marketingowych (za zgoda Uzytkownika),
            </li>
            <li>poprawy funkcjonowania Platformy.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§4 Podstawa prawna przetwarzania danych</h2>
          <p>Dane osobowe sa przetwarzane na podstawie:</p>
          <ul>
            <li>art. 6 ust. 1 lit. b RODO - wykonanie umowy,</li>
            <li>art. 6 ust. 1 lit. c RODO - obowiazek prawny,</li>
            <li>art. 6 ust. 1 lit. a RODO - zgoda Uzytkownika,</li>
            <li>
              art. 6 ust. 1 lit. f RODO - prawnie uzasadniony interes
              Administratora.
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>§5 Odbiorcy danych</h2>
          <p>Dane osobowe moga byc przekazywane:</p>
          <ul>
            <li>firmom ksiegowym,</li>
            <li>operatorom platnosci,</li>
            <li>dostawcom uslug IT i hostingowych,</li>
            <li>firmom obslugujacym system mailingowy,</li>
            <li>organom publicznym - na podstawie przepisow prawa.</li>
          </ul>
          <p>
            Dane nie sa przekazywane poza Unie Europejska, chyba ze zapewniony
            jest odpowiedni poziom ochrony.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§6 Okres przechowywania danych</h2>
          <p>Dane osobowe sa przechowywane:</p>
          <ul>
            <li>przez czas trwania umowy,</li>
            <li>
              po jej zakonczeniu - przez okres wymagany przepisami prawa,
            </li>
            <li>
              do momentu cofniecia zgody - w przypadku danych przetwarzanych na
              jej podstawie.
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>§7 Prawa osob, ktorych dane dotycza</h2>
          <p>Uzytkownik ma prawo do:</p>
          <ul>
            <li>dostepu do danych,</li>
            <li>ich sprostowania,</li>
            <li>usuniecia (prawo do bycia zapomnianym),</li>
            <li>ograniczenia przetwarzania,</li>
            <li>przenoszenia danych,</li>
            <li>wniesienia sprzeciwu,</li>
            <li>cofniecia zgody w dowolnym momencie,</li>
            <li>
              wniesienia skargi do organu nadzorczego, tj. Prezesa Urzedu
              Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa,
              www.uodo.gov.pl).
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>§8 Zabezpieczenie danych</h2>
          <p>
            Administrator stosuje srodki techniczne i organizacyjne zapewniajace
            ochrone danych osobowych, w szczegolnosci:
          </p>
          <ul>
            <li>certyfikat SSL,</li>
            <li>zabezpieczenia serwerow,</li>
            <li>systemy kontroli dostepu,</li>
            <li>regularne aktualizacje oprogramowania.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>§9 Pliki cookies</h2>
          <ol>
            <li>
              Sklep wykorzystuje pliki cookies w celu:
              <ul>
                <li>prawidlowego dzialania strony,</li>
                <li>analizy statystyk,</li>
                <li>celow marketingowych.</li>
              </ul>
            </li>
            <li>
              Uzytkownik moze zarzadzac plikami cookies za pomoca ustawien
              przegladarki.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§10 Produkty cyfrowe</h2>
          <ol>
            <li>
              Platforma oferuje wylacznie produkty cyfrowe w postaci wykrojow
              krawieckich.
            </li>
            <li>Po dokonaniu zakupu Klient otrzymuje dostep do plikow do pobrania.</li>
            <li>Produkty cyfrowe objete sa ochrona praw autorskich.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§11 Marketing i newsletter</h2>
          <ol>
            <li>
              Uzytkownik moze zapisac sie do newslettera za dobrowolna zgoda.
            </li>
            <li>Zgoda moze byc cofnieta w dowolnym momencie.</li>
            <li>
              Dane wykorzystywane do celow marketingowych nie sa przekazywane
              osobom trzecim.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§12 Zautomatyzowane podejmowanie decyzji i profilowanie</h2>
          <p>
            Dane osobowe nie sa wykorzystywane do zautomatyzowanego podejmowania
            decyzji ani profilowania.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§13 Postanowienia koncowe</h2>
          <ol>
            <li>
              Administrator zastrzega sobie prawo do zmian niniejszej Polityki
              Prywatnosci.
            </li>
            <li>Zmiany wchodza w zycie z dniem publikacji na stronie Platformy.</li>
            <li>
              Aktualna wersja dokumentu jest zawsze dostepna na stronie
              internetowej.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>Administrator Danych Osobowych</h2>
          <p>Nazwa firmy: {LEGAL_CONFIG.companyName}</p>
          <p>Adres: {LEGAL_CONFIG.companyAddress}</p>
          <p>E-mail: {LEGAL_CONFIG.supportEmail}</p>
          <p>Data ostatniej aktualizacji: {LEGAL_CONFIG.privacyPolicyLastUpdated}</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
